import { render } from "./CompanyValue.vue?vue&type=template&id=561ebab6&scoped=true&ts=true"
import script from "./CompanyValue.vue?vue&type=script&lang=ts"
export * from "./CompanyValue.vue?vue&type=script&lang=ts"

import "./CompanyValue.vue?vue&type=style&index=0&id=561ebab6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561ebab6"]])

export default __exports__